export const SELECTORS = {
  SLIDER: 'js-photo-card-slider',
  OVERLAY: 'js-photo-card-slider-overlay',
  PREV_BTN: 'js-photo-card-slider-prev-btn',
  NEXT_BTN: 'js-photo-card-slider-next-btn',
  CLOSE_BTN: 'js-photo-card-slider-close-btn',
  IMG: 'js-photo-card-slider-img'
};

export const MOBILE_PHOTOS_AMOUNT = 3;
export const DESKTOP_PHOTOS_AMOUNT = 4;

export const LARGE_PHOTO_SIZE = 400;
export const SMALL_PHOTO_SIZE = 96;
